module.exports = __webpack_public_path__ + "media/images/players/UIHLEIN_PETER-e3aa0c21106083235c4235b13da6790d.png";